import React from 'react';
import { connect } from 'react-redux';
import GoogleTagManager from '@package/components/GoogleTagManager/GoogleTagManager';
import { Helmet } from '@plone/volto/helpers';

const RAZZLE_GMAPS_API_KEY = __CLIENT__
  ? window?.env?.RAZZLE_GMAPS_API_KEY || process.env.RAZZLE_GMAPS_API_KEY
  : process.env.RAZZLE_GMAPS_API_KEY;

const GlobalAppExtras = ({ pathname }) => {
  return (
    <>
      <Helmet titleTemplate={`%s - ModenaTur`} />
      {RAZZLE_GMAPS_API_KEY && (
        <Helmet>
          <script
            src={`https://maps.googleapis.com/maps/api/js?key=${RAZZLE_GMAPS_API_KEY}&libraries=places`}
          ></script>
        </Helmet>
      )}
      <GoogleTagManager />
    </>
  );
};

export default connect(
  (state, props) => ({
    pathname: props.location?.pathname,
  }),
  {},
)(GlobalAppExtras);
